import Icon from '../components/Icon.vue'

Icon.register({"external-link-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 928v-480q0-26-19-45t-45-19h-480q-42 0-59 39-17 41 14 70l144 144-534 534q-19 19-19 45t19 45l102 102q19 19 45 19t45-19l534-534 144 144q18 19 45 19 12 0 25-5 39-17 39-59zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/external-link-square.js